import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Animation drivers by node path: an AnimationPlayer or a GLB driver publishes
 * its object and clips whenever they are available, whatever the selection.
 * An AnimationTree resolves its `anim_player` here. Without a provider,
 * register does nothing and the lookup gives null.
 */
import { createContext, useCallback, useContext, useState } from 'react';
const NO_OP_REGISTER = () => () => { };
const EMPTY_DRIVERS = new Map();
const RegisterDriverContext = createContext(NO_OP_REGISTER);
RegisterDriverContext.displayName = 'RegisterDriverContext';
const DriversContext = createContext(EMPTY_DRIVERS);
DriversContext.displayName = 'AnimationDriversContext';
/** Stable, so a publishing driver's effect does not re-fire on every map change. */
export function useRegisterDriver() {
    return useContext(RegisterDriverContext);
}
/** Reactive, so an AnimationTree re-renders when its target appears. */
export function useAnimationDriver(path) {
    const drivers = useContext(DriversContext);
    return path === null ? null : (drivers.get(path) ?? null);
}
export function AnimationDriverProvider({ children }) {
    const [drivers, setDrivers] = useState(() => new Map());
    const registerDriver = useCallback((path, entry) => {
        setDrivers((prev) => {
            const next = new Map(prev);
            next.set(path, entry);
            return next;
        });
        return () => {
            setDrivers((prev) => {
                // Only this exact entry, so a remount that re-registered first survives.
                if (prev.get(path) !== entry)
                    return prev;
                const next = new Map(prev);
                next.delete(path);
                return next;
            });
        };
    }, []);
    return (_jsx(RegisterDriverContext.Provider, { value: registerDriver, children: _jsx(DriversContext.Provider, { value: drivers, children: children }) }));
}
//# sourceMappingURL=AnimationDriverContext.js.map